//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DeleteCouponApi } from '../api';
export default {
  name: 'DeleteCoupon',
  props: {
    getList: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isShow: false,
      id: null
    };
  },
  methods: {
    open: function open(id) {
      this.id = id;
      this.isShow = true;
    },
    close: function close() {
      this.isShow = false;
    },
    submit: function submit() {
      var _this = this;
      DeleteCouponApi(this.id).then(function () {
        _this.$message.success('删除成功');
        _this.getList();
        _this.close();
      }).catch(function () {
        _this.close();
      });
    }
  }
};